import { useState, useEffect, useCallback } from 'react'
import api from '../services/api'

/**
 * Hook para la vista calendario mensual de vacaciones/ausencias.
 * Devuelve un mapa { 'YYYY-MM-DD': [ausencias...] } expandiendo los rangos.
 */
export function useCalendarioVacaciones(mes, filtros = {}) {
  const [ausencias, setAusencias] = useState([])
  const [porDia, setPorDia] = useState({})
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState(null)

  const cargar = useCallback(async () => {
    if (!mes) return
    setCargando(true); setError(null)
    try {
      const r = await api.get('/ausencias/calendario', { params: { mes, ...filtros } })
      const lista = r.data || []
      setAusencias(lista)
      setPorDia(expandirAusencias(lista, mes))
    } catch (e) {
      setError(e.message || 'Error')
    } finally {
      setCargando(false)
    }
  }, [mes, JSON.stringify(filtros)])

  useEffect(() => { cargar() }, [cargar])

  return { ausencias, porDia, cargando, error, recargar: cargar }
}

// Expande cada ausencia día a día dentro del mes pedido.
function expandirAusencias(lista, mesYYYYMM) {
  if (!mesYYYYMM) return {}
  const [anio, mesNum] = mesYYYYMM.split('-').map(Number)
  const inicio = new Date(anio, mesNum - 1, 1)
  const fin = new Date(anio, mesNum, 0)
  const out = {}
  lista.forEach((a) => {
    const fIni = new Date(a.fecha_inicio)
    const fFin = new Date(a.fecha_fin)
    const cursorIni = fIni < inicio ? inicio : fIni
    const cursorFin = fFin > fin ? fin : fFin
    for (let d = new Date(cursorIni); d <= cursorFin; d.setDate(d.getDate() + 1)) {
      const key = d.toISOString().slice(0, 10)
      if (!out[key]) out[key] = []
      out[key].push(a)
    }
  })
  return out
}
